<br><br>
<app-gestiones-header-preca [buttonselected]=5 [participante]="participante" [gestionSeleccionada]="gestionSeleccionada" (selecttab)="selectedtab($event)" (selectParticipante)="selectedparticipante($event)"></app-gestiones-header-preca>
<div class="container-fluid">
    <div class="row table-full">
        <div class="table-data" >
        <div class="table4"  *ngIf="gestionSeleccionada.participante[participante].codigoSegmentoProducto === 'PRIVADO'">
          <table class="table table-borderless" *ngIf="gestionSeleccionada.participante[participante].tipoParticipante === 'DEUDOR'">
            <thead class="thead-light">
              <tr>
                <th colspan="6" scope="col">INFORMACIÓN DE LA PRE SOLICITUD</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th *ngIf="participante==0">DPI DEUDOR</th>
                <th *ngIf="participante==1">DPI CODEUDOR</th>
                <th>SEGMENTO</th>
                <th>MONTO SOLICITADO</th>
                <th>PLAZO SOLICITADO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[participante].datosGenerales.dpi}}</td>
                <td>{{gestionSeleccionada.participante[participante].codigoSegmentoProducto}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.monto| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.plazo}} meses</td>
              </tr>
              <tr>
                <th>TASA BANCA BT</th>
                <th>CUOTA NIVELADA</th>
                <th>PRIMA CON SEGURO MENSUAL</th>
                <th>CUOTA CON SEGURO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.tasa | number:'1.2-2'}}%</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCredito| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.primaSeguroMensual| currency:"Q "}}</td>
                <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg!='1'">
                  {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro|
                  currency:"Q "}}
                </td>
                <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                  {{getcuotamym()|
                  currency:"Q "}}
                </td>
                <td *ngIf="participante==1">
                  {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro*0.2|
                  currency:"Q "}}
                </td>
              </tr>
              <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                <th>AHORRO MENSUAL</th>
                <th>CUOTA TOTAL MENSUAL</th>
                <th></th>
                <th></th>
              </tr>
              <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchAhorroMensual| currency:"Q "}}
                <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro| currency:"Q "}}
                <td></td>
                <td></td>
              </tr>
              <tr>
                <th>TOTAL CONSOLIDACIÓN</th>
                <th>COMISIÓN DESEMBOLSO</th>
                <th>INTERÉS FIN DE MES</th>
                <th>PRIMA SEGURO ANUAL</th>
              </tr>
              <tr>
                <td>{{setConsolidacionTotal()|
                  currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.comisionDesembolso| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.interesFinDeMes| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.primaSeguroAnual| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>CUOTAS CONSOLIDADAS BANTRAB</th>
                <th>CUOTAS CONSOLIDADAS SIB EXTERNAS</th>
                <th>LIQUIDO A RECIBIR</th>
                <th>NUMERO PATRONO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].outCuotaConsolidacionDeudasBT| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outCuotaCreditoConsolidarExterna| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.liquidezRecibir| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.numeroPatrono}}</td>
              </tr>
              <tr>
                <th>NOMBRE PATRONO</th>
                <th>SCORE PREDICTIVO INTERNO</th>
                <th>CLIENTE EXISTENTE</th>
                <th>FECHA DE INICIO LABORES</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.nombrePatrono}}</td>
                <td>{{ gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.scoreDeudorSeleccionado|number:'1.0-0' }}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='E'">Si</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='N' || gestionSeleccionada.participante[this.participante].outTipoCliente=='R' ">No</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.fechaInicioEmpleoActual}}</td>
              </tr>
              <tr>
                <th>SALARIO NOMINAL</th>
                <th>BONIFICACIÓN</th>
                <th>COMISIONES</th>
                <th>OTROS INGRESOS</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppSalarioBase| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppBonificaciones| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppComisiones| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrosIngresos| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>IGSS</th>
                <th>ISR</th>
                <th>JUDICIALES</th>
                <th>OTRAS DEDUCCIONES</th>
              </tr>
              <tr>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS==''">Q 0.00</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR==''">Q 0.00</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppDescuentosJudiciales| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrasDeducciones| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>SALARIO LIQUIDO</th>
                <th>CUOTA PENDIENTE PAGAR</th>
                <th>CONTINUIDAD LABORAL</th>
                <th>SOLICITA CODEUDOR</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].outIngresoLiquido| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outUnaCuotaPendientePagar| currency:"Q "|ReplaceText: 'Q 0.00'}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.otroEmpleo}}</td>
                <td *ngIf="gestionSeleccionada.participante.length==1">NO</td>
                <td *ngIf="gestionSeleccionada.participante.length==2">SI</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-borderless" *ngIf="gestionSeleccionada.participante[participante].tipoParticipante === 'CODEUDOR'">
            <thead class="thead-light">
            <tr>
              <th colspan="6" scope="col">INFORMACIÓN DE LA PRE SOLICITUD</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th *ngIf="participante==0">DPI DEUDOR</th>
              <th *ngIf="participante==1">DPI CODEUDOR</th>
              <th>SEGMENTO</th>
              <th>MONTO SOLICITADO</th>
              <th>PLAZO SOLICITADO</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[participante].datosGenerales.dpi}}</td>
              <td>{{gestionSeleccionada.participante[participante].codigoSegmentoProducto}}</td>
              <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.monto| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.plazo}} meses</td>
            </tr>
            <tr>
              <th>TASA BANCA BT</th>
              <th>CUOTA CON SEGURO CODEUDOR</th>
              <th>NUMERO PATRONO</th>
              <th>NOMBRE PATRONO</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.tasa | number:'1.2-2'}}%</td>
              <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg!='1'">
                {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro|
                currency:"Q "}}
              </td>
              <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                {{getcuotamym()|
                currency:"Q "}}
              </td>
              <td *ngIf="participante==1">
                {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro * 0.2 |
                currency:"Q "}}
              </td>
              <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.numeroPatrono}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.nombrePatrono}}</td>
            </tr>
            <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1' && participante==0 ">
              <th>AHORRO MENSUAL</th>
              <th>CUOTA TOTAL MENSUAL</th>
              <th></th>
              <th></th>
            </tr>
            <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1' && participante==0">
              <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchAhorroMensual| currency:"Q "}}
              <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro| currency:"Q "}}
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th>SCORE PREDICTIVO INTERNO</th>
              <th>CLIENTE EXISTENTE</th>
              <th>FECHA DE INICIO LABORES</th>
              <th>CONTINUIDAD LABORAL</th>
            </tr>
            <tr>
              <td>{{ gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.scoreCodeudorSeleccionado|number:'1.0-0' }}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='E'">Si</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='N' || gestionSeleccionada.participante[this.participante].outTipoCliente=='R' ">No</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.fechaInicioEmpleoActual}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.otroEmpleo}}</td>
            </tr>
            <tr>
              <th>SALARIO NOMINAL</th>
              <th>BONIFICACIÓN</th>
              <th>COMISIONES</th>
              <th>OTROS INGRESOS</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppSalarioBase| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppBonificaciones| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppComisiones| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrosIngresos| currency:"Q "}}</td>
            </tr>
            <tr>
              <th>IGSS</th>
              <th>ISR</th>
              <th>JUDICIALES</th>
              <th>OTRAS DEDUCCIONES</th>
            </tr>
            <tr>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS| currency:"Q "}}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS==''">Q 0.00</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR| currency:"Q "}}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR==''">Q 0.00</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppDescuentosJudiciales| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrasDeducciones| currency:"Q "}}</td>
            </tr>
            <tr>
              <th>SALARIO LIQUIDO</th>
              <th>CUOTA PENDIENTE PAGAR</th>
              <th></th>
              <th></th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[this.participante].outIngresoLiquido| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].outUnaCuotaPendientePagar| currency:"Q "|ReplaceText: 'Q 0.00'}}</td>
              <td ></td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="table4" *ngIf="gestionSeleccionada.participante[participante].codigoSegmentoProducto === 'ESTADO'">
            <table class="table table-borderless" *ngIf="gestionSeleccionada.participante[participante].tipoParticipante === 'DEUDOR'">
              <thead class="thead-light">
              <tr>
                <th colspan="6" scope="col">INFORMACIÓN DE LA PRE SOLICITUD</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th *ngIf="participante==0">DPI DEUDOR</th>
                <th *ngIf="participante==1">DPI CODEUDOR</th>
                <th>SEGMENTO</th>
                <th>MONTO SOLICITADO</th>
                <th>PLAZO SOLICITADO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[participante].datosGenerales.dpi}}</td>
                <td>{{gestionSeleccionada.participante[participante].codigoSegmentoProducto}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.monto| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.plazo}} meses</td>
              </tr>
              <tr>
                <th>TASA BANCA BT</th>
                <th>CUOTA NIVELADA</th>
                <th>PRIMA CON SEGURO MENSUAL</th>
                <th>CUOTA CON SEGURO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.tasa | number:'1.2-2'}}%</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCredito| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.primaSeguroMensual| currency:"Q "}}</td>
                <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg!='1'">
                  {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro|
                  currency:"Q "}}
                </td>
                <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                  {{getcuotamym()|
                  currency:"Q "}}
                </td>
                <td *ngIf="participante==1">
                  {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro*0.2|
                  currency:"Q "}}
                </td>
              </tr>
              <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                <th>AHORRO MENSUAL</th>
                <th>CUOTA TOTAL MENSUAL</th>
                <th></th>
                <th></th>
              </tr>
              <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchAhorroMensual| currency:"Q "}}
                <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro| currency:"Q "}}
                <td></td>
                <td></td>
              </tr>
              <tr>
                <th>TOTAL CONSOLIDACIÓN</th>
                <th>COMISIÓN DESEMBOLSO</th>
                <th>INTERÉS FIN DE MES</th>
                <th>REGLON PRESUPUESTARIO</th>
              </tr>
              <tr>
                <td>{{setConsolidacionTotal()|
                  currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.comisionDesembolso| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.interesFinDeMes| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.reglonPresupuestario}}</td>
              </tr>
              <tr>
                <th>PRIMA SEGURO ANUAL</th>
                <th>CUOTAS CONSOLIDADAS BANTRAB</th>
                <th>CUOTAS CONSOLIDADAS SIB EXTERNAS</th>
                <th>LIQUIDO A RECIBIR</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.primaSeguroAnual| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outCuotaConsolidacionDeudasBT| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outCuotaCreditoConsolidarExterna| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.liquidezRecibir| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>NUMERO PATRONO</th>
                <th>NOMBRE PATRONO</th>
                <th>SCORE PREDICTIVO INTERNO</th>
                <th>CATEGORÍA PATRONO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.numeroPatrono}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.nombrePatrono}}</td>
                <td>{{ gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.scoreDeudorSeleccionado|number:'1.0-0' }}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.categoriaGasto}}</td>
              </tr>
              <tr>
                <th>CODIGO EMPLEADO</th>
                <th>POSEE INDICE</th>
                <th>CLIENTE EXISTENTE</th>
                <th>FECHA DE INICIO LABORES</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.identificadorEmpleado}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice=='S'">Si</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice!='S'">No</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='E'">Si</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='N' || gestionSeleccionada.participante[this.participante].outTipoCliente=='R' ">No</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.fechaInicioEmpleoActual}}</td>
              </tr>
              <tr>
                <th>SALARIO NOMINAL</th>
                <th>BONIFICACIÓN</th>
                <th>COMISIONES</th>
                <th>OTROS INGRESOS</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppSalarioBase| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppBonificaciones| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppComisiones| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrosIngresos| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>IGSS</th>
                <th>ISR</th>
                <th>JUDICIALES</th>
                <th>OTRAS DEDUCCIONES</th>
              </tr>
              <tr>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS==''">Q 0.00</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR==''">Q 0.00</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppDescuentosJudiciales| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrasDeducciones| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>CUOTA INDICE</th>
                <th>SALARIO LIQUIDO</th>
                <th>SALARIO LIQUIDO BT</th>
                <th>CUOTA PENDIENTE PAGAR</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.valorDescuentoCuotaBantrab| currency:"Q "|ReplaceText: 'Q 0.00' }}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outIngresoLiquido| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].codigoSegmentoProducto=='ESTADO'&& gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice=='S'">{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.salarioLiquido| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].codigoSegmentoProducto=='ESTADO' && gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice!='S'">Sin indices</td>
                <td>{{gestionSeleccionada.participante[this.participante].outUnaCuotaPendientePagar| currency:"Q "|ReplaceText: 'Q 0.00'}}</td>
              </tr>
              <tr>
                <th>CONTINUIDAD LABORAL</th>
                <th>SOLICITA CODEUDOR</th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.otroEmpleo}}</td>
                <td *ngIf="gestionSeleccionada.participante.length==1">NO</td>
                <td *ngIf="gestionSeleccionada.participante.length==2">SI</td>
                <td></td>
                <td></td>
              </tr>
              </tbody>
            </table>
            <table class="table table-borderless" *ngIf="gestionSeleccionada.participante[participante].tipoParticipante === 'CODEUDOR'">
            <thead class="thead-light">
            <tr>
              <th colspan="6" scope="col">INFORMACIÓN DE LA PRE SOLICITUD</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th *ngIf="participante==0">DPI DEUDOR</th>
              <th *ngIf="participante==1">DPI CODEUDOR</th>
              <th>SEGMENTO</th>
              <th>MONTO SOLICITADO</th>
              <th>PLAZO SOLICITADO</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[participante].datosGenerales.dpi}}</td>
              <td>{{gestionSeleccionada.participante[participante].codigoSegmentoProducto}}</td>
              <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.monto| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.plazo}} meses</td>
            </tr>
            <tr>
              <th>TASA BANCA BT</th>
              <th>CUOTA CON SEGURO CODEUDOR</th>
              <th>REGLON PRESUPUESTARIO</th>
              <th>CONTINUIDAD LABORAL</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.tasa | number:'1.2-2'}}%</td>
              <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg!='1'">
                {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro|
                currency:"Q "}}</td>
              <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                {{getcuotamym()|
                currency:"Q "}}</td>
              <td *ngIf="participante==1">
                {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro * 0.2 |
                currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.reglonPresupuestario}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.otroEmpleo}}</td>
            </tr>
            <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1' && participante==0">
              <th>AHORRO MENSUAL</th>
              <th>CUOTA TOTAL MENSUAL</th>
              <th></th>
              <th></th>
            </tr>
            <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'&& participante==0">
              <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchAhorroMensual| currency:"Q "}}
              <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro| currency:"Q "}}
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th>NUMERO PATRONO</th>
              <th>NOMBRE PATRONO</th>
              <th>SCORE PREDICTIVO INTERNO</th>
              <th>CATEGORÍA PATRONO</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.numeroPatrono}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.nombrePatrono}}</td>
              <td>{{ gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.scoreCodeudorSeleccionado|number:'1.0-0' }}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.categoriaGasto}}</td>
            </tr>
            <tr>
              <th>CODIGO EMPLEADO</th>
              <th>POSEE INDICE</th>
              <th>CLIENTE EXISTENTE</th>
              <th>FECHA DE INICIO LABORES</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.identificadorEmpleado}}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice=='S'">Si</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice!='S'">No</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='E'">Si</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='N' || gestionSeleccionada.participante[this.participante].outTipoCliente=='R' ">No</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.fechaInicioEmpleoActual}}</td>
            </tr>
            <tr>
              <th>SALARIO NOMINAL</th>
              <th>BONIFICACIÓN</th>
              <th>COMISIONES</th>
              <th>OTROS INGRESOS</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppSalarioBase| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppBonificaciones| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppComisiones| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrosIngresos| currency:"Q "}}</td>
            </tr>
            <tr>
              <th>IGSS</th>
              <th>ISR</th>
              <th>JUDICIALES</th>
              <th>OTRAS DEDUCCIONES</th>
            </tr>
            <tr>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS| currency:"Q "}}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS==''">Q 0.00</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR| currency:"Q "}}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR==''">Q 0.00</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppDescuentosJudiciales| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrasDeducciones| currency:"Q "}}</td>
            </tr>
            <tr>
              <th>CUOTA INDICE</th>
              <th>SALARIO LIQUIDO</th>
              <th>SALARIO LIQUIDO BT</th>
              <th>CUOTA PENDIENTE PAGAR</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.valorDescuentoCuotaBantrab| currency:"Q "|ReplaceText: 'Q 0.00'}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].outIngresoLiquido| currency:"Q "}}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].codigoSegmentoProducto=='ESTADO'&& gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice=='S'">{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.salarioLiquido| currency:"Q "}}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].codigoSegmentoProducto=='ESTADO' && gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice!='S'">Sin indices</td>
              <td>{{gestionSeleccionada.participante[this.participante].outUnaCuotaPendientePagar| currency:"Q "|ReplaceText: 'Q 0.00'}}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="table4"  *ngIf="gestionSeleccionada.participante[participante].codigoSegmentoProducto === 'PAGO_VOLUNTARIO'">
          <table class="table table-borderless" *ngIf="gestionSeleccionada.participante[participante].tipoParticipante === 'DEUDOR'">
            <thead class="thead-light">
              <tr>
                <th colspan="6" scope="col">INFORMACIÓN DE LA PRE SOLICITUD</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th *ngIf="participante==0">DPI DEUDOR</th>
                <th *ngIf="participante==1">DPI CODEUDOR</th>
                <th>SEGMENTO</th>
                <th>MONTO SOLICITADO</th>
                <th>PLAZO SOLICITADO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[participante].datosGenerales.dpi}}</td>
                <td>{{gestionSeleccionada.participante[participante].codigoSegmentoProducto}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.monto| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.plazo}} meses</td>
              </tr>
              <tr>
                <th>TASA BANCA BT</th>
                <th>CUOTA NIVELADA</th>
                <th>PRIMA CON SEGURO MENSUAL</th>
                <th>CUOTA CON SEGURO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.tasa | number:'1.2-2'}}%</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCredito| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.primaSeguroMensual| currency:"Q "}}</td>
                <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg!='1'">
                  {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro|
                  currency:"Q "}}</td>
                  <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                    {{getcuotamym()|
                    currency:"Q "}}</td>
                <td *ngIf="participante==1">
                  {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro*0.2|
                  currency:"Q "}}</td>
              </tr>
              <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                <th>AHORRO MENSUAL</th>
                <th>CUOTA TOTAL MENSUAL</th>
                <th></th>
                <th></th>
              </tr>
              <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchAhorroMensual| currency:"Q "}}
                <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro| currency:"Q "}}
                <td></td>
                <td></td>
              </tr>
              <tr>
                <th>TOTAL CONSOLIDACIÓN</th>
                <th>COMISIÓN DESEMBOLSO</th>
                <th>INTERÉS FIN DE MES</th>
                <th>PRIMA SEGURO ANUAL</th>
              </tr>
              <tr>
                <td>{{setConsolidacionTotal()|
                  currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.comisionDesembolso| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.interesFinDeMes| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.primaSeguroAnual| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>CUOTAS CONSOLIDADAS BANTRAB</th>
                <th>CUOTAS CONSOLIDADAS SIB EXTERNAS</th>
                <th>LIQUIDO A RECIBIR</th>
                <th>NUMERO PATRONO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].outCuotaConsolidacionDeudasBT| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outCuotaCreditoConsolidarExterna| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.liquidezRecibir| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.numeroPatrono}}</td>
              </tr>
              <tr>
                <th>NOMBRE PATRONO</th>
                <th>SCORE PREDICTIVO</th>
                <th>FUENTE DE INGRESOS</th>
                <th>CLIENTE EXISTENTE</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.nombrePatrono}}</td>
                <td>{{ gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.scoreDeudorSeleccionado|number:'1.0-0' }}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].codigoSegmentoProducto=='PAGO_VOLUNTARIO'">{{gestionSeleccionada.participante[this.participante].codigoSegmentoRiesgoPagoVoluntario}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='E'">Si</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='N' || gestionSeleccionada.participante[this.participante].outTipoCliente=='R' ">No</td>
              </tr>
              <tr>
                <th>FECHA DE INICIO LABORES</th>
                <th>SALARIO NOMINAL</th>
                <th>BONIFICACIÓN</th>
                <th>COMISIONES</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.fechaInicioEmpleoActual}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppSalarioBase| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppBonificaciones| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppComisiones| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>OTROS INGRESOS</th>
                <th>IGSS</th>
                <th>ISR</th>
                <th>JUDICIALES</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrosIngresos| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS==''">Q 0.00</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR==''">Q 0.00</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppDescuentosJudiciales| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>OTRAS DEDUCCIONES</th>
                <th>SALARIO LIQUIDO</th>
                <th>CUOTA PENDIENTE PAGAR</th>
                <th>CONTINUIDAD LABORAL</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrasDeducciones| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outIngresoLiquido| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outUnaCuotaPendientePagar| currency:"Q "|ReplaceText: 'Q 0.00'}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.otroEmpleo}}</td>
              </tr>
              <tr>
                <th>SOLICITA CODEUDOR</th>
              </tr>
              <tr>
                <td *ngIf="gestionSeleccionada.participante.length==1">NO</td>
                <td *ngIf="gestionSeleccionada.participante.length==2">SI</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-borderless" *ngIf="gestionSeleccionada.participante[participante].tipoParticipante === 'CODEUDOR'">
            <thead class="thead-light">
            <tr>
              <th colspan="6" scope="col">INFORMACIÓN DE LA PRE SOLICITUD</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th *ngIf="participante==0">DPI DEUDOR</th>
              <th *ngIf="participante==1">DPI CODEUDOR</th>
              <th>SEGMENTO</th>
              <th>MONTO SOLICITADO</th>
              <th>PLAZO SOLICITADO</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[participante].datosGenerales.dpi}}</td>
              <td>{{gestionSeleccionada.participante[participante].codigoSegmentoProducto}}</td>
              <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.monto| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.plazo}} meses</td>
            </tr>
            <tr>
              <th>TASA BANCA BT</th>
              <th>CUOTA CON SEGURO CODEUDOR</th>
              <th>NUMERO PATRONO</th>
              <th>NOMBRE PATRONO</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.tasa | number:'1.2-2'}}%</td>
              <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg!='1'">
                {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro|
                currency:"Q "}}
              </td>
              <td *ngIf="participante==0 && gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1'">
                {{getcuotamym()|
                currency:"Q "}}
              </td>
              <td *ngIf="participante==1">
                {{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro * 0.2 |
                currency:"Q "}}
              </td>
              <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.numeroPatrono}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.nombrePatrono}}</td>
            </tr>
            <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1' && participante==0 ">
              <th>AHORRO MENSUAL</th>
              <th>CUOTA TOTAL MENSUAL</th>
              <th></th>
              <th></th>
            </tr>
            <tr *ngIf="gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchFlg=='1' && participante==0">
              <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchAhorroMensual| currency:"Q "}}
              <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro| currency:"Q "}}
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th>SCORE PREDICTIVO</th>
              <th>CLIENTE EXISTENTE</th>
              <th>FECHA DE INICIO LABORES</th>
              <th>CONTINUIDAD LABORAL</th>
            </tr>
            <tr>
              <td>{{ gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.scoreCodeudorSeleccionado|number:'1.0-0' }}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='E'">Si</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='N' || gestionSeleccionada.participante[this.participante].outTipoCliente=='R' ">No</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.fechaInicioEmpleoActual}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.otroEmpleo}}</td>
            </tr>
            <tr>
              <th>SALARIO NOMINAL</th>
              <th>BONIFICACIÓN</th>
              <th>COMISIONES</th>
              <th>OTROS INGRESOS</th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppSalarioBase| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppBonificaciones| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppComisiones| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrosIngresos| currency:"Q "}}</td>
            </tr>
            <tr>
              <th>IGSS</th>
              <th>ISR</th>
              <th>JUDICIALES</th>
              <th>OTRAS DEDUCCIONES</th>
            </tr>
            <tr>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS| currency:"Q "}}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS==''">Q 0.00</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR| currency:"Q "}}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR==''">Q 0.00</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppDescuentosJudiciales| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrasDeducciones| currency:"Q "}}</td>
            </tr>
            <tr>
              <th>SALARIO LIQUIDO</th>
              <th>CUOTA PENDIENTE PAGAR</th>
              <th *ngIf="gestionSeleccionada.segmentoProducto=='PAGO_VOLUNTARIO'">FUENTE DE INGRESOS</th>
              <th *ngIf="gestionSeleccionada.segmentoProducto!='PAGO_VOLUNTARIO'"></th>
              <th></th>
            </tr>
            <tr>
              <td>{{gestionSeleccionada.participante[this.participante].outIngresoLiquido| currency:"Q "}}</td>
              <td>{{gestionSeleccionada.participante[this.participante].outUnaCuotaPendientePagar| currency:"Q "|ReplaceText: 'Q 0.00'}}</td>
              <td *ngIf="gestionSeleccionada.participante[this.participante].codigoSegmentoProducto=='PAGO_VOLUNTARIO'">{{gestionSeleccionada.participante[this.participante].codigoSegmentoRiesgoPagoVoluntario}}</td>
              <td *ngIf="gestionSeleccionada.segmentoProducto!='PAGO_VOLUNTARIO'"></td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
      </div>
</div>
